import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ProposalDetails from './ProposalDetails';

import {
  loadProposalById,
  getProposalFundTxOffline,
  setTxProcessStart,
  setTxProcessError,
  setTxProcessResponse,
  resetTxProcess,
  setAccounts,
} from '../../../../store/actions/proposalsActions';

import {
  selectCurrentProposal,
  selectTxFeeEstimation,
  selectTxRawData,
  selectTxProcessError,
  selectTxProcessResponse,
  getAccounts,
} from '../../../../store/selectors/proposalsSelectors';

import withMessaging from '../../../common/withMessaging';

export default connect(
  (state) => ({
    accounts: getAccounts(state),
    proposal: selectCurrentProposal(state),
    isProposalsLoading: state.proposals.isLoading,
    proposalsLoadingError: state.proposals.error,
    feeEstimation: selectTxFeeEstimation(state),
    rawTx: selectTxRawData(state),
    txProcessResponse: selectTxProcessResponse(state),
    txProcessError: selectTxProcessError(state),
    isTxProcessLoading: state.proposals.isTxProcessLoading,
  }),
  (dispatch) => ({
    actions: {
      ...bindActionCreators(
        {
          loadProposalById,
          resetTxProcess,
          setTxProcessStart,
          getProposalFundTxOffline,
          setAccounts,
          setTxProcessResponse,
          setTxProcessError,
        },
        dispatch
      ),
    },
  })
)(withMessaging(ProposalDetails));
